import { render } from "./LocalizedTextInput.vue?vue&type=template&id=3033afb4"
import script from "./LocalizedTextInput.vue?vue&type=script&lang=ts"
export * from "./LocalizedTextInput.vue?vue&type=script&lang=ts"

import "./LocalizedTextInput.vue?vue&type=style&index=0&id=3033afb4&lang=scss"
script.render = render

export default script